import React from "react";
import MemberHeader from "./MemberHeader";
import MobxPageContent from "shared/components/MobxPageContent";
import {observer} from "mobx-react";
import PropTypes from "prop-types";
import ContentHeader from "gradifui/components/section/ContentHeader";
import CookieConsent from "shared/components/CookieConsent";
import EphemeralBanner from "shared/components/message/EphemeralBanner";
import IENotSupportedBanner from "shared/components/message/IENotSupportedBanner";
import Chatbot from "../../shared/components/Chatbot";
import Propulator from "../../higher-order/Propulator";

@observer
class MemberPageContent extends React.Component {
    static propTypes = {
        selectedHeaderItem: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
        sectionName: PropTypes.string,
        showChatbot: PropTypes.bool
    };

    render() {
        const header = (
            <MemberHeader
                selected={this.props.selectedHeaderItem}
            />
        );
        const {ephemeralBanner, showChatbot} = this.props;
        return (
            <MobxPageContent header={header} disclaimers={this.props.disclaimers}>
                <IENotSupportedBanner/>
                {showChatbot === true &&
                    <Chatbot isEmployer={false}/>
                }
                {ephemeralBanner &&
                    <EphemeralBanner
                        bannerHeaderContentKey={ephemeralBanner.headerContentKey}
                        bannerMessageContentKey={ephemeralBanner.messageContentKey}
                        ctaLink={ephemeralBanner.ctaLink}
                        ctaText={ephemeralBanner.ctaText}
                        ctaOpenInNewTab={false}
                        ctaVisible={false}
                    />
                }
                {this.props.sectionName &&
                    <ContentHeader name={this.props.sectionName}/>
                }
                {this.props.children}
                <CookieConsent/>
            </MobxPageContent>
        );
    }
}

export default Propulator(MemberPageContent, {
    sessionStore: [
        "environment",
        "session"
    ]
});
